import apiUtil, { throwApiError } from '~/utils/apiUtils'

const { post } = apiUtil()

interface GenerateBooleanSearchRequest {
  positionId: string
  requiredSkills: string[]
  optionalSkills?: string[]
}

class LinkedInAPI {
  constructor() {}

  // Generate a boolean search query for LinkedIn
  async generateBooleanSearch(
    payload: GenerateBooleanSearchRequest,
  ): Promise<any> {
    try {
      const response = await post('/linkedin/generate', payload)

      if (!response.ok) {
        await throwApiError(response)
      }

      const json = await response.json()
      console.log('>>>>> LinkedIn API response', json)
      return json.linkedInBooleanLogic
    } catch (error) {
      console.error('Error generating LinkedIn boolean search:', error)
      throw error
    }
  }
}

const linkedInApi = new LinkedInAPI()
export default linkedInApi
